import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Grid from "@material-ui/core/Grid";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DynamicForm from "f1-dynamic-form-react";
import CloseIcon from "@mui/icons-material/Close";

import "./inventoryRecords.scss";
import { FILTER_FORM_ACCOUNT_WISE } from "../formData";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { ApiUrls } from "../../api/baseURL";
import { post } from "../../api/api";
import useOnlineStatus from "../../useOnlineStatus";
import Loader from "../../components/loader/loader";
import { metaDataConstants } from "../../utils/Constants/constants-en";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  drawerMobile: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  desktopFilter: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

function AccountWiseProductLising(props) {

  const classes = useStyles();
  const [state, setState] = useState({ top: false });
  const [inventoryCountType, setInventoryCountType] = useState('');

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const [totalProductCount, setTotalProductCount] = useState([]);

  const resetFilters = () => {
    setActivateLoader(true);
    setCurrent({
      account: "null",
    });
    setTotalProductCount([]);
    setSelectedCategory([]);
    setOptions([]);
    setLabelData({
      accountName: null,
      period: null,
      dueDate: null,
    });
    setActivateLoader(false);
  };

  const [activateLoader, setActivateLoader] = useState(false);
  const [candidateDetail, setCandidateDetail] = useState(
    FILTER_FORM_ACCOUNT_WISE
  );
  const [show, setShow] = useState(false);
  const [serverityStatus, setServerityStatus] = useState("");

  const [uniqueCategory, setUniqueCategory] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [current, setCurrent] = useState({
    account: "null",
    location: null,
    storageArea: null,
  });
  const isOnline = useOnlineStatus();
  const [labelData, setLabelData] = useState({
    accountName: null,
    period: null,
    dueDate: null,
  });
  const [accounId, setAccountId] = useState(0);
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [showOfflineText, setShowOfflineText] = useState(true);

  const getDropdownData = (optionsArr, key, label) => {
    const arr = optionsArr?.map((item) => {
      return {
        key: item[key],
        label: item[label]?.charAt(0)?.toUpperCase() + item[label]?.slice(1),
        value: item[key],
      };
    });
    arr.unshift({ key: "select", label: "Select", value: "" });
    return arr;
  };

  useEffect(() => {
    if (isOnline) {
      setShowOfflineText(false);
      getAccount();
    }
  }, []);

  const getAccount = async () => {
    const payload = {
      IsActive: 1,
      accountId: null,
      workflowModuleKey: "INVENTORY_COUNT_FILL",
      moduleKey: 1,
      masterId: null,
      timeOffset: -330,
      isIncludePosted: 0,
      take: 1000,
      skip: 0,
      page: 1,
      pageSize: 1000,
    };
    setActivateLoader(true);

    const response = await post(ApiUrls().GET_ACCOUNTS, payload).catch(function (error) {
      // Handle errors here
      setActivateLoader(false);
      console.error("Error:", error);
    });

    if (response?.status === 200) {
      setActivateLoader(false);
      const data = response?.data.result;
      setAccountData(response?.data.result);
      const copyFormData = [...candidateDetail];
      copyFormData[0].options = getDropdownData(
        data,
        "accountId",
        "accountName"
      );
      setCandidateDetail(copyFormData);
    } else {
      setActivateLoader(false);
    }
  };

  const onSubmitHandler = async (model, anchor) => {
    if (model.account == "null") {
      return false;
    }
    if (
      (!model.isValidForm && Object.keys(model.errors).length > 0) ||
      Object.keys(model.errors).length > 0
    ) {
      return false;
    }

    setActivateLoader(true);

    if (anchor) {
      setState({ ...state, [anchor]: false });
    }
    const accData = accountData?.filter((el) => el.accountId == model.account);

    setLabelData({
      ...labelData,
      accountName: accData[0].accountName,
      period: accData[0].inventoryPeriod,
      dueDate: accData[0].dueDate?.slice(0, 10),
    });
    let acc = accountData.filter((item) => item.accountId === parseInt(current.account))
    acc && setInventoryCountType(acc[0].inventoryCountTypeMetadataName)

    const payload = {
      AccountId: 0,
      ProductName: null,
      productId: 0,
      IsActive: 1,
      inventoryCheckAccountId: accData[0].id,
      categoryId: 0,
    };

    const response = await post(ApiUrls().INVENTORY_COUNT, payload).catch(function (error) {
      setActivateLoader(false);
      console.error("Error:", error);
    });

    if (response?.status === 200) {
      const data = response?.data.result;
      setActivateLoader(false);
      const categoryValues = acc[0]?.inventoryCountTypeMetadataName === "Category Based" ? data.map((item) => item.categoryName) : data.map((item) => item.storageName);
      const uniquecategory = [...new Set(categoryValues)];
      setUniqueCategory(uniquecategory);
      setSelectedCategory(uniquecategory);
      setTotalProductCount(data);
      const valueLabel = uniquecategory.map((item, index) => ({
        value: item,
        label: item,
      }));
      setOptions(valueLabel);
    } else {
      setActivateLoader(false);
    }
  };

  const onFilterChange = async (event, key, model) => {
    if (key === "account") {
      const accountId = event?.target?.value;
      setCurrent({
        ...current,
        account: accountId,
      });
      setAccountId(accountId);
    }
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    if (value === "all") {
      setSelectedCategory(uniqueCategory);
    } else {
      const ar = [value];
      setSelectedCategory(ar);
    }
  };

  return (
    <div className="container containerMainDiv">
      <div className="contentdivBg pt-0">
        <div className="divRound pt-4">
          {showOfflineText ? (
            <p style={{ marginTop: "10%", color: "red" }}>
              {metaDataConstants.youAreOffline}
            </p>
          ) : null}{" "}
          <h3 className="form-title">{metaDataConstants.invertoryRecords}</h3>
          <div className="activityList" style={{ margin: "0" }}>
            <div className="tabBox"></div>
            <Grid className="activiPad0" container columns={{ xs: 4, md: 12 }}>
              <Grid item xs={12} md={9} className="leftCol">
                <Grid spacing={3} container textalign="left" className="mr-3">
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>Account</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>
                        {labelData.accountName ? labelData.accountName : null}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>{metaDataConstants.period}</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>{labelData.period ? labelData.period : null}</span>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>{metaDataConstants.dueDate}</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>
                        {labelData.dueDate ? labelData.dueDate : null}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <Grid container>
                      <Grid item xs={6}>
                        <span
                          style={{
                            fontWeight: "bold",
                            padding: ".5rem 0 0",
                            display: "block",
                          }}
                        >
                          {inventoryCountType === "Storage Area Based" ? 'Storage' : 'Category'}
                        </span>
                      </Grid>
                      <Grid item xs={6} style={{ textAlign: "right" }}>
                        {" "}
                        <select
                          className="dropdown mt-2"
                          value={selectedValue}
                          onChange={handleSelectChange}
                        >
                          <option value="all">{metaDataConstants.all}</option>
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <div className="mt-4"></div>
                <Grid
                  container
                  spacing={5}
                  textalign="left"
                  className="p-2 productListDiv"
                >
                  {selectedCategory?.map((it, index) => {
                    const keys = Object.keys(it);
                    return (
                      <Grid item xs={12} md={4}>
                        <p
                          style={{
                            background: "#00dac9",
                            margin: "-1rem -.5rem 1.5rem",
                            fontWeight: "bold",
                            padding: ".25rem .5rem",
                            color: "#fff ",
                          }}
                        >
                          {it}
                        </p>
                        {totalProductCount?.filter((el) => {
                          if (inventoryCountType !== "Storage Area Based") {
                            return el.categoryName === it
                          }
                          else return el.storageName === it
                        })
                          ?.map((item, index) => {
                            return (
                              <div style={{ minHeight: "310px" }}>
                                <Grid
                                  container
                                  alignItems="center"
                                  spacing={3}
                                  style={{ position: "relative" }}
                                  className="cardBoxAcivity"
                                >
                                  <Paper className={classes.paper}>
                                    <Grid item xs={12}>
                                      <Grid
                                        container
                                        spacing={3}
                                        className="cardTop"
                                      >
                                        <Grid item xs={12}>
                                          <Typography
                                            variant="h5"
                                            component="h2"
                                            className={classes.heading}
                                          >
                                            <b className="mobHeader">
                                              {metaDataConstants.productNumberLabel}
                                            </b>
                                            <span className="branchName">
                                              {item.productCode}
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={12}
                                          md={5}
                                          className="buttonBox"
                                        ></Grid>
                                      </Grid>
                                      <Grid container className="labelGroup">
                                        <Grid
                                          item
                                          xs={6}
                                          className={classes.subHeading}
                                        >
                                          <label>{metaDataConstants.productNameLabel}</label>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <span className="subHeadBlue">
                                            <span
                                              className={classes.subHeadingBold}
                                            >
                                              {item.productName}
                                            </span>
                                          </span>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={6}
                                          className={classes.subHeading}
                                        >
                                          <label>{metaDataConstants.unit1} {item.uomName1}</label>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <span className="subHeadBlue">
                                            <span
                                              className={classes.subHeadingBold}
                                            >
                                              {item.uomEnteredStock1}
                                            </span>
                                          </span>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={6}
                                          className={classes.subHeading}
                                        >
                                          <label>{metaDataConstants.unit2} {item.uomName2}</label>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <span className="subHeadBlue">
                                            <span
                                              className={classes.subHeadingBold}
                                            >
                                              {item.uomEnteredStock2}
                                            </span>
                                          </span>
                                        </Grid>

                                        <Grid
                                          item
                                          xs={6}
                                          className={classes.subHeading}
                                        >
                                          <label>{metaDataConstants.unit3} {item.uomName3}</label>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <span className="subHeadBlue">
                                            <span
                                              className={classes.subHeadingBold}
                                            >
                                              {item.uomEnteredStock3}
                                            </span>
                                          </span>
                                        </Grid>

                                        <Grid
                                          item
                                          xs={6}
                                          className={classes.subHeading}
                                        >
                                          <label>
                                            {metaDataConstants.unitTotalQuantityLabel}{" "}
                                            {item.unitTotalQuantityUOMCode}
                                          </label>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <span
                                            className={classes.subHeadingBold}
                                          >
                                            {item.unitTotalQuantity}
                                          </span>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Paper>
                                </Grid>
                              </div>
                            );
                          })}
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
              <Grid item xs={12} md={3} className="rightCol">
                <div className={classes.desktopFilter}>
                  <div className="filterBox ml-3">
                    <h4 className="filterSec">
                      {" "}
                      <FilterAltIcon className="icnFilter" /> {metaDataConstants.filterBy}
                    </h4>
                    <DynamicForm
                      key={"filterId"}
                      title={" "}
                      buttonSubmit={"APPLY FILTER"}
                      defaultValues={current}
                      model={FILTER_FORM_ACCOUNT_WISE}
                      onSubmit={(model) => {
                        onSubmitHandler(model);
                      }}
                      disableSubmitOnInValid={false}
                      design="bootrstap" // material/bootrstap/advanceMaterial/advanceBootstrap
                      materialOutline={false}
                      onChange={(event, key) => onFilterChange(event, key)}
                      showAstersikOnRequiredFields={true}
                      className="productFilters"
                      extaraActionFormButton={
                        <span className="reset" onClick={resetFilters}>
                          <RestartAltIcon /> {metaDataConstants.reset}
                        </span>
                      }
                    />
                  </div>
                </div>

                <span className={classes.drawerMobile}>
                  {["right"].map((anchor) => (
                    <React.Fragment key={anchor}>
                      <div className="float-right">
                        <Box
                          className="editBtn"
                          sx={{ "& > :not(style)": { m: 1 } }}
                          onClick={toggleDrawer(anchor, true)}
                        >
                          <span className="icnFilterBox">
                            {" "}
                            {metaDataConstants.filterBy}
                            <FilterAltIcon />{" "}
                          </span>
                        </Box>
                      </div>
                      <SwipeableDrawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                      >
                        <div className="filterBox">
                          <h4 className="filterSec">
                            <FilterAltIcon className="icnFilter" /> {metaDataConstants.filterBy}{" "}
                            <span
                              style={{ float: "right" }}
                              onClick={toggleDrawer(anchor, false)}
                            >
                              <CloseIcon />
                            </span>
                          </h4>
                          <DynamicForm
                            key={"filterId"}
                            title={" "}
                            buttonSubmit={metaDataConstants.applyFilter}
                            defaultValues={current}
                            model={FILTER_FORM_ACCOUNT_WISE}
                            onSubmit={(model) => {
                              onSubmitHandler(model, anchor);
                            }}
                            disableSubmitOnInValid={false}
                            design="bootrstap" // material/bootrstap/advanceMaterial/advanceBootstrap
                            materialOutline={false}
                            onChange={(event, key) =>
                              onFilterChange(event, key)
                            }
                            showAstersikOnRequiredFields={true}
                            className="activityFilters activityFiltersMobile"
                            extaraActionFormButton={
                              <span
                                className="reset"
                                onClick={() => resetFilters(anchor)}
                                style={{ marginRight: 15 }}
                              >
                                <RestartAltIcon /> {metaDataConstants.reset}
                              </span>
                            }
                          />
                          <Loader active={activateLoader} />
                        </div>
                      </SwipeableDrawer>
                    </React.Fragment>
                  ))}
                </span>
              </Grid>
            </Grid>
            <div>
              <Loader active={activateLoader} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountWiseProductLising;
